import * as React from 'react';

import {Button} from 'shells/button/button';
import {ButtonGroup} from 'shells/button-group/button-group';
// @ts-expect-error - imported from .js/.jsx file
import {ActivityEmptyStateIcon} from 'shells/icon/svg/activity-empty-state-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EmailIcon} from 'shells/icon/svg/email-icon';
// @ts-expect-error - imported from .js/.jsx file
import {NoteIcon} from 'shells/icon/svg/note-icon';
import {InlineTab} from 'shells/tabs/inline-tabs/inline-tab';
import {InlineTabs} from 'shells/tabs/inline-tabs/inline-tabs';

import {SmsSidebarButton} from '../../inbox/sidebar/sms/sms-sidebar-button';

import type {ContentType} from './timeline-creator';

import styles from './timeline-creator-tabs.module.css';

type Props = {
    entityId: string;
    entityPageName: string | null | undefined;
    selectedTab: ContentType;
    onChange: (selectedTab: ContentType) => void;
    onShowEmail: () => void;
};

export function TimelineCreatorTabs(props: Props) {
    return (
        <div className={styles.container}>
            <div className={styles.tabs}>
                <InlineTabs
                    name='timelineCreator'
                    selectedTab={props.selectedTab}
                    onChange={props.onChange}
                    isDark={true}
                    tabMinWidth={150}
                >
                    <InlineTab value='ACTIVITY'>
                        <div className={styles.tab}>
                            <ActivityEmptyStateIcon size={16} className={styles.icon} />
                            <span>Log an activity</span>
                        </div>
                    </InlineTab>
                    <InlineTab value='NOTE'>
                        <div className={styles.tab}>
                            <NoteIcon size={16} className={styles.icon} />
                            <span>Write a note</span>
                        </div>
                    </InlineTab>
                </InlineTabs>
            </div>
            <ButtonGroup>
                <SmsSidebarButton entityId={props.entityId} entityPageName={props.entityPageName} />
                <Button
                    icon={EmailIcon}
                    size='big'
                    variant='primary'
                    onClick={() => {
                        props.onShowEmail();
                    }}
                >
                    Send an email
                </Button>
            </ButtonGroup>
        </div>
    );
}
